module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABQCAYAAAC+neOMAAAAv0lEQVR42u3bMQrAIBAAQV/r/39gCKRIY0BFNN4U28ox1SmYSimpt5zzXamURs7ebZ4EChQoUDtDPYePVB1sUVPm+TpYr0CBAgUK1OFQUdeDdqhoCycoUKBARYaqtgiqe55pUKcFChSof0EFzaXY6wEoUKBAgbIeTH/htHCCAgUKFChQoECBAgUKFChQoECBAgUKFChQoECBAgUKFChQoECBAgUKFChQoECBAgUKFChQoPwA9QPU7ypQoEAJVEsX6+Q5OGm0c0QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warning_calendar.png
// module id = 1039
// module chunks = 0